var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zlkTabsList"},[_c('ul',_vm._l((_vm.List),function(item,index){return _c('li',{key:index},[_c('TabsList',{staticClass:"tabsList",attrs:{"tabsList":item},on:{"getmore":_vm.goTo,"clickTabsList":_vm.goDetails}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8db80522","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/project/ZlkTabsList1.vue
// module id = null
// module chunks = 